import { actionGenerator } from '@mopla/utils';

export enum EFeatureFlagActionTypes {
	FetchFeatureFlags = '[FeatureFlag] Fetch Feature Flags',
	FetchFeatureFlagsResult = '[FeatureFlag] Fetch Feature Flags Result',
}

/** Map of API-driven feature flags. Currently empty — no flag is fetched from the
 * backend after `isNewHomePageAvailable` was removed. Kept so new API flags can be added. */
export type IFeatureFlagsResponse = Record<string, boolean>;

export interface IFetchFeatureFlagsResultPayload {
	featureFlags?: IFeatureFlagsResponse;
	error?: any;
}
export const fetchFeatureFlags =
	actionGenerator<EFeatureFlagActionTypes.FetchFeatureFlags>(
		EFeatureFlagActionTypes.FetchFeatureFlags
	);

export const fetchFeatureFlagsResult = actionGenerator<
	EFeatureFlagActionTypes.FetchFeatureFlagsResult,
	IFetchFeatureFlagsResultPayload
>(EFeatureFlagActionTypes.FetchFeatureFlagsResult);

export type TFetchFeatureFlagsAction = ReturnType<typeof fetchFeatureFlags>;
export type TFetchFeatureFlagsResultAction = ReturnType<
	typeof fetchFeatureFlagsResult
>;
